module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-3__75a6c9e82ca59f863ab581c52cd15e98.png";